// @ts-check
import { z } from 'zod';

import DocumentParties from '@/store/modules/bulkSend/models/DocumentParties';
import Timestamp from '@/store/modules/models/global/Timestamp';

export const Party = z.object({
  fingerprint: z.string(),
  role: z.string(),
  created_at: Timestamp,
  updated_at: Timestamp,
  document_parties: DocumentParties.nullable(),
});

export const Parties = Party.array();

const SavedParty = Party.transform(party => ({
  fingerprint: party.fingerprint,
  role: party.role,
  document_party_ids: party.document_parties?.map(p => p.id),
}));

export const SavedParties = SavedParty.array();

/** @typedef {z.infer<typeof Party>} TParty */
/** @typedef {z.infer<typeof Parties>} TParties */
/** @typedef {z.infer<typeof SavedParty>} TSavedParty */
/** @typedef {{base: boolean} & Pick<TSavedParty, 'role' | 'document_party_ids'>} TNewParty */
/** @typedef {TNewParty[]} TNewParties */
/** @typedef {TSavedParty | TNewParty} TUpdateParty */
/** @typedef {TUpdateParty[]} TUpdateParties */
